import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {GeneralService} from '../../services/general.service';
import {Response, Request, StaticMethods} from '../../model/GeneralModels';
import {AppSettingsService} from '../../services/app-settings.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ]
})
export class MyRequestsComponent implements OnInit {
  productName: string;
  requests: Request[];
  backUrl: string;
  newRequestUrl: string;
  translation: any = {};

  constructor(private activatedRoute: ActivatedRoute,
              private generalService: GeneralService,
              public settings: AppSettingsService,
              private dialog: MatDialog,
              private router: Router) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      console.log(params.productName);
      this.productName = params.productName;
      this.getRequests(this.productName);
      this.backUrl = StaticMethods.getBaseUrl(this.productName);
      this.newRequestUrl = this.backUrl + '/basic-information';
    });
  }

  getRequests(productName: string) {
    this.generalService.getRequestsList(this.productName).subscribe((response: Response) => {
      if (response.success) {
        this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
        this.requests = [];
        response.data.forEach(request => {
          const index = this.requests.length;
          this.requests[index] = new Request(request.requestID, request.dateOfCreation, productName, request.status);
        });
      }
    });
  }

  newRequest() {
    this.router.navigate([this.newRequestUrl]);
  }

  openDialog(requestID: number) {
    StaticMethods.openDialog(this.dialog, 'آیا از حذف این درخواست مطمئن هستید؟', (result) => {
      if (result) {
        this.generalService.deleteRequest(requestID, this.productName, 'user delete').subscribe((response: Response) => {
          if (response.success) {
            this.getRequests(this.productName);
            StaticMethods.showMessage(response.message);
          }
        });
      }
    });
  }

  getDetails(request: Request) {
    const baseUrl = '/' + StaticMethods.getBaseUrl(request.productName);
    this.router.navigate([`${baseUrl}/details`], {
      state: {
        icon: request.icon,
        requestID: request.id
      }
    });
  }

  goBack() {
    const baseUrl = StaticMethods.getBaseUrl(this.productName);
    this.router.navigate(['/' + baseUrl]);
  }
}
